/* eslint-disable */

import "jquery-match-height";
import "@fancyapps/fancybox";
import "vide";
import "owl.carousel";

// add mute/unmute to homepage video
$("#player-vol-controls").click(function (e) {
  if ($("video").prop("muted") == true) {
    $("video").prop("muted", false);
    $("#player-vol-controls > p").empty();
    $("#player-vol-controls > p").append(
      '<span class="icon-volume-high"></span>'
    );
  } else {
    $("video").prop("muted", true);
    $("#player-vol-controls > p").empty();
    $("#player-vol-controls > p").append(
      '<span class="icon-volume-mute"></span>'
    );
  }
});

if ($('body').hasClass('home')) {
  let videoEl = document.querySelector('.landing-video');
  // is homepage, prepare video
  if ($('.landing-video').length > 0) {
    if (window.innerWidth >= 992) {
      videoEl.play();
    } else {
      // videoEl.pause();
    }
    // resize listener
    $(window).on('resize', function () {
      // is homepage, prepare video
      if (window.innerWidth >= 992) {
        videoEl.play();
      } else {
        // videoEl.pause();
      }

    });
  }

  // add event listener to handle playing pausing based upon window width
}

function setPaddings() {
  var container = $(".container:visible").width();
  var win = $(window).width();
  var padding = (win - container) / 2;
}

function setPagination() {
  if ($(".post-navigation").length > 0) {
    $(".post-navigation ul.page-numbers li a.prev")
      .parent("li")
      .addClass("prev-page");
    $(".post-navigation ul.page-numbers li a.next")
      .parent("li")
      .addClass("next-page");
    $(".post-navigation ul.page-numbers li a.prev").addClass("nav-button");
    $(".post-navigation ul.page-numbers li a.next").addClass("nav-button");
    if ($(".post-navigation ul.page-numbers li.prev-page").length === 0) {
      $(".post-navigation ul.page-numbers").prepend(
        '<li class="prev-page off"><i class="icon-arrow-left"></i></li>'
      );
    }
    if ($(".post-navigation ul.page-numbers li.next-page").length === 0) {
      $(".post-navigation ul.page-numbers").append(
        '<li class="next-page off"><i class="icon-arrow-right"></i></li>'
      );
    }
    $(".post-navigation ul.page-numbers")
      .find(".current")
      .parent("li")
      .addClass("current-page");
  }
}

$('#accept-cookies').click(function (e) {
  e.preventDefault();
  var expires = "";
  let days = 999;
  let name = 'cookie_accepted';
  let value = 1;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
  $(this).parent().parent().hide()
})

export default {
  init() {
    $("#burger-wrapper").on("click", function () {
      $("#mainHeader").toggleClass("opened");
      $(this).toggleClass("opened");
      $("#responsive-menu-wrapper").slideToggle();
    });

    $("#partners-slider")
      .owlCarousel({
        loop: true,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 4500,
        margin: 30,
        singleItem: false,
        stagePadding: 0,
        autoWidth: false,
        smartSpeed: 1050,
        slideBy: 1,
        responsive: {
          0: {
            items: 2
          },
          768: {
            items: 3
          },
          992: {
            items: 5
          },
          1200: {
            items: 5
          }
        }
      })
      .trigger("refresh.owl.carousel");
  },
  finalize() {
    $(window).load(function () {
      setPaddings();
      setPagination();

      $(".body-wrapper").removeClass("lock");
      $("#partners-slider").trigger("refresh.owl.carousel");

      $.fn.matchHeight._update();
      $(".initial-hidden").css("opacity", 1);
    });

    $(window).resize(function () {
      setPaddings();
      $.fn.matchHeight._update();
    });
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js